import React from "react"
import { Transition } from "react-spring/renderprops"
import Layout from "../components/Layout"
import Lottie from "react-lottie"
import phoneData from '../lotties/Phone.json'
import packageData from '../lotties/Package.json'

const ComingSoon = (props) => {
	const { addSection, sections, destinationIndex } = props

	addSection("ComingSoon")

	const sectionIndex = sections.findIndex((section) => section === "ComingSoon")
	const loaded = destinationIndex === sectionIndex

	let size = window.matchMedia("(max-width: 767px)").matches ? "mobile" : "desktop"
  let imageSize = size === "mobile" ? 20 : 44
  const getOptions = (data) => {
    return { loop: true,
      autoplay: true,
      animationData: data,
      containerStyle: {
        width: "100%",
        height: "100%",
      },
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice"
      }}
      
  }

	return (
		<>
			<Layout>
				{loaded && (
					<div style={styles.fullText}>
						<Transition
							from={{ opacity: 0, transform: "translate3d(0,-40px,0)" }}
							enter={{ opacity: 1, transform: "translate3d(0,0px,0)" }}
						>
							{(item) => (styleProps) =>
								<p style={{ ...styleProps, ...styles.titleText, fontSize: size === "mobile" ? "30px" : "54px" }}>2026 Moving Faster</p>}
						</Transition>
						<div
							style={{
								...styles.blurb,
								marginLeft: size === "mobile" ? "-5%" : "0%",
								marginRight: size === "mobile" ? "5%" : "0%",
                fontSize: size === "mobile" ? "16px" : "26px",
                maxWidth: size === "desktop" ? "970px" : "100%"
							}}
						>
													<Transition
								from={{ opacity: 0, transform: "translate3d(0,-40px,0)" }}
								enter={{ opacity: 1, transform: "translate3d(0,0px,0)" }}
								delay={100}
							>
								{(item) => (styleProps) =>
									(
										<div style={{ ...styleProps, marginTop: "20px" }}>
											<p style={styles.headlineText}>2025 delivered on your demand for innovation:</p>
										</div>
									)}
							</Transition>
							<Transition
								from={{ opacity: 0, transform: "translate3d(0,-40px,0)" }}
								enter={{ opacity: 1, transform: "translate3d(0,0px,0)" }}
							>
								{(item) => (styleProps) =>
									(
										<div style={{ ...styleProps }}>
                      <span style={styles.highlightText}>
                        <div>
                          <Lottie 
                            options={getOptions(phoneData)}
                            height={imageSize}
                            width={imageSize}
                          />
                        </div>New Master Tour Mobile is live on iOS and Android!</span>
                      <p style={styles.standardText}>Add dates, track flights, manage your industry profile and stay connected anywhere.</p>
										</div>
									)}
							</Transition>
							<Transition
								from={{ opacity: 0, transform: "translate3d(0,-40px,0)" }}
								enter={{ opacity: 1, transform: "translate3d(0,0px,0)" }}
								delay={100}
							>
								{(item) => (styleProps) =>
									(
										<div style={{ ...styleProps, marginTop: "20px" }}>
											<span style={styles.highlightText}>
                        <div>
                          <Lottie 
                            options={getOptions(packageData)}
                            height={imageSize}
                            width={imageSize}
                          />
                        </div>Venue Tech Packs are now the industry's most complete source of production data</span>
											<p style={styles.standardText}>Video walk-throughs, hi-res photos, and 200+ timestamped specs that sync directly to your tour events.</p>
										</div>
									)}
							</Transition>
              <Transition
								from={{ opacity: 0, transform: "translate3d(0,-40px,0)" }}
								enter={{ opacity: 1, transform: "translate3d(0,0px,0)" }}
								delay={100}
							>
								{(item) => (styleProps) =>
									(
										<div style={{ ...styleProps, marginTop: "20px" }}>
											<p style={styles.headlineText}>In 2026, our products will get sharper: Faster updates, deeper integrations, and smarter workflows that keep tours and venues in sync.</p>
										</div>
									)}
							</Transition>
						</div>
					</div>
				)}
			</Layout>
		</>
	)
}

const styles = {
	fullText: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		marginTop: "7.5%",
    	marginBottom: "1%",
		width: "100%",
	},
	blurb: {
		textAlign: "left",
		display: "flex",
		flexDirection: "column",
		marginTop: "1em",
	},
	highlightText: {
		color: "#FF5151",
		fontWeight: "800",
    	display: "flex",
    	alignItems: "center",
		gap: "10px",
	},
	standardText: {
		fontWeight: "400",
		paddingLeft: "3em",
	},
	headlineText: {
		fontWeight: "600",
		fontSize: "1.2em",
	},
	titleText: {
		fontWeight: "700",
    	marginTop: "1.5em"
	},
}

export default ComingSoon
